<template>
    <div class="primary--text">
        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{ $t("cap_inter") }}
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="intermedias" :cargando="cargando"
                                          v-model="solucionConstructiva.materialCapaIntermedia"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import SeleccionComponenteSC from "../../Componentes/SeleccionComponenteSC";

    export default {
        name: "ComponentesHorizontal",
        model: {
            prop: 'correcto',
            event: 'change'
        },
        components: {
            SeleccionComponenteSC
        },
        props: {
            solucionConstructiva: {type: Object, required: true},
            correcto: {type: Boolean, default: false},
        },
        data: function () {
            return {
                intermedias: [],
                cargando: false
            }
        },
        mounted() {
            this.cargarCapasIntermedia().then(() => {
                this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
            });
        },
        watch: {
            solucionConstructiva: {
                handler() {
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                },
                deep: true
            }
        },
        methods: {
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            cargarCapasIntermedia() {
                this.cargando = true;
                let promise = HttpHelper.get('obra-nueva/horizontal/solucion-constructiva/'
                    + this.solucionConstructiva.id + '/capa-intermedia');
                promise.then(data => {
                    this.intermedias = data;
                }).finally(() => {
                    this.cargando = false;
                });

                return promise;
            },
            solucionConstructivaEsCorrecta(solucionConstructiva) {
                if (solucionConstructiva.materialCapaIntermedia === null) return false;

                return true;
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "cap_inter": "Capa intermedia"
    }
    }
</i18n>
<!--@formatter:on-->